module.exports = "<div>\n  <p>App works</p>\n  <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/jvutukur/Downloads/HeatMap/ng-heatmap/ng-heatmap/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main